import { FC } from 'react';
import { IconWrapper } from '../IconWrapper';
import { IconProps } from '../Icons.types';

const InfoFilled: FC<IconProps> = (allProps) => {
  const { svgProps: props, ...restProps } = allProps;
  return (
    <IconWrapper
      componentName='InfoFilled'
      icon={
        <svg
          width='inherit'
          height='inherit'
          viewBox='0 0 32 32'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
          {...props}
        >
          <path
            d='M16 4C13.6266 4 11.3066 4.70379 9.33316 6.02236C7.35977 7.34094 5.8217 9.21508 4.91345 11.4078C4.0052 13.6005 3.76756 16.0133 4.23058 18.3411C4.6936 20.6689 5.83649 22.807 7.51472 24.4853C9.19295 26.1635 11.3311 27.3064 13.6589 27.7694C15.9867 28.2324 18.3995 27.9948 20.5922 27.0865C22.7849 26.1783 24.6591 24.6402 25.9776 22.6668C27.2962 20.6934 28 18.3734 28 16C27.9966 12.8184 26.7313 9.76814 24.4816 7.51843C22.2319 5.26872 19.1816 4.00336 16 4ZM15.5385 9.53846C15.8123 9.53846 16.08 9.61967 16.3077 9.77181C16.5354 9.92395 16.7129 10.1402 16.8177 10.3932C16.9225 10.6462 16.9499 10.9246 16.8965 11.1932C16.843 11.4618 16.7112 11.7085 16.5175 11.9021C16.3239 12.0958 16.0772 12.2277 15.8086 12.2811C15.54 12.3345 15.2616 12.3071 15.0086 12.2023C14.7556 12.0975 14.5393 11.92 14.3872 11.6923C14.2351 11.4646 14.1538 11.1969 14.1538 10.9231C14.1538 10.5559 14.2997 10.2037 14.5594 9.944C14.8191 9.68434 15.1712 9.53846 15.5385 9.53846ZM16.9231 22.4615C16.4334 22.4615 15.9639 22.267 15.6177 21.9208C15.2714 21.5746 15.0769 21.105 15.0769 20.6154V16C14.8321 16 14.5973 15.9027 14.4242 15.7296C14.2511 15.5565 14.1538 15.3217 14.1538 15.0769C14.1538 14.8321 14.2511 14.5973 14.4242 14.4242C14.5973 14.2511 14.8321 14.1538 15.0769 14.1538C15.5666 14.1538 16.0361 14.3483 16.3824 14.6946C16.7286 15.0408 16.9231 15.5104 16.9231 16V20.6154C17.1679 20.6154 17.4027 20.7126 17.5758 20.8857C17.7489 21.0589 17.8462 21.2936 17.8462 21.5385C17.8462 21.7833 17.7489 22.0181 17.5758 22.1912C17.4027 22.3643 17.1679 22.4615 16.9231 22.4615Z'
            fill='currentColor'
          />
        </svg>
      }
      {...restProps}
    />
  );
};

export default InfoFilled;
